export default __webpack_public_path__ + "static/media/higher_primary_logo_tagline_url_reversed.74bd1b15.svg";